import { render, staticRenderFns } from "./companyCardList.vue?vue&type=template&id=38c9525e&scoped=true"
import script from "./companyCardList.vue?vue&type=script&lang=js"
export * from "./companyCardList.vue?vue&type=script&lang=js"
import style0 from "./companyCardList.vue?vue&type=style&index=0&id=38c9525e&lang=scss&scoped=true"
import style1 from "./companyCardList.vue?vue&type=style&index=1&id=38c9525e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c9525e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c9525e')) {
      api.createRecord('38c9525e', component.options)
    } else {
      api.reload('38c9525e', component.options)
    }
    module.hot.accept("./companyCardList.vue?vue&type=template&id=38c9525e&scoped=true", function () {
      api.rerender('38c9525e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/companyCardList.vue"
export default component.exports